module.exports = {"430972005":"朝阳街道","430972006":"东部产业园","430972109":"谢林港镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430972.json
// module id = 1890
// module chunks = 0